import React, { useMemo } from 'react';
import { Tag } from 'antd';
import {
  FaPhone,
  FaCommentDots,
  FaInstagram,
  FaQuestionCircle,
} from 'react-icons/fa';

export const useEngagementModeRender = () => {
  return useMemo(
    () => (mode: string) => {
      const modeConfigs: Record<
        string,
        {
          text: string;
          icon: React.ReactNode;
          bgColor: string;
          textColor: string;
          borderColor: string;
        }
      > = {
        CALL: {
          text: 'Call',
          icon: <FaPhone />,
          bgColor: '#e6f7ff',
          textColor: '#1890ff',
          borderColor: '#91d5ff',
        },
        WHATSAPP: {
          text: 'WhatsApp',
          icon: <FaCommentDots />,
          bgColor: '#f6ffed',
          textColor: '#52c41a',
          borderColor: '#b7eb8f',
        },
        INSTAGRAM: {
          text: 'Instagram',
          icon: <FaInstagram />,
          bgColor: '#fff0f6',
          textColor: '#eb2f96',
          borderColor: '#ffadd2',
        },
        OTHER: {
          text: 'Other',
          icon: <FaQuestionCircle />,
          bgColor: '#fafafa',
          textColor: '#8c8c8c',
          borderColor: '#d9d9d9',
        },
      };

      const config = modeConfigs[mode] || {
        text: mode || 'Unknown',
        icon: <FaQuestionCircle />,
        bgColor: '#f5f5f5',
        textColor: '#8c8c8c',
        borderColor: '#d9d9d9',
      };

      return (
        <Tag
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontWeight: 500,
            padding: '4px 8px',
            borderRadius: '6px',
            lineHeight: '1.2',
            backgroundColor: config.bgColor,
            color: config.textColor,
            border: `1px solid ${config.borderColor}`,
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {config.icon}
          </span>
          <span>{config.text}</span>
        </Tag>
      );
    },
    []
  );
};
